import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";

import {

  BookOpen,

  GraduationCap,

  CalendarClock,

  Zap,

  CheckCircle2,

  Globe,

  Users,

  MessageCircle,

  CreditCard,

  Star,

  HelpCircle,

  BadgeCheck,

  PhoneCall,

} from "lucide-react";



const whatsapp = "+961 79 181 431";
const what="+966541230242";

const email = "ulearnacademy.edu@gmail.com";

const primaryColor = "#5c87ff";



function Section({ id, children, className = "" }) {

  return (

    <section id={id || undefined} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 ${className}`}>

      {children}

    </section>

  );

}



function Pill({ children }) {

  return (

    <span

      className="inline-flex items-center rounded-full border px-3 py-1 text-xs sm:text-sm"

      style={{ borderColor: primaryColor, color: primaryColor }}

    >

      {children}

    </span>

  );

}



function Button({ href = "#", children, filled = false, className = "" }) {

  const base = "rounded-2xl px-5 py-3 text-sm inline-flex items-center justify-center";

  const styles = filled

    ? { backgroundColor: primaryColor, borderColor: primaryColor, color: "#ffffff" }

    : { border: `1px solid ${primaryColor}`, color: primaryColor };

  return (

    <a href={href} className={`${base} ${className}`} style={styles}>

      {children}

    </a>

  );

}



function Feature({ Icon, title, desc }) {

  return (

    <div className="p-6 rounded-2xl border shadow-sm bg-white/60 backdrop-blur" style={{ borderColor: primaryColor }}>

      <div className="flex items-start gap-4">

        <div className="p-2 rounded-xl border bg-white/30" style={{ borderColor: primaryColor }}>

          <Icon className="w-6 h-6" style={{ color: primaryColor }} />

        </div>

        <div>

          <h3 className="font-semibold text-lg">{title}</h3>

          <p className="text-sm text-gray-600 mt-2">{desc}</p>

        </div>

      </div>

    </div>

  );

}



function FAQItem({ q, a, center = false, className = "" }) {

  return (

    <details

      className={`group border rounded-2xl p-5 bg-white/60 backdrop-blur ${center ? "mx-auto" : ""} ${className}`}

      style={{ borderColor: primaryColor }}

    >

      <summary className="cursor-pointer list-none flex items-center justify-between gap-4">

        <span className="font-medium">{q}</span>

        {!center && <HelpCircle className="w-5 h-5 shrink-0" style={{ color: primaryColor }} />}

      </summary>

      <p className={`mt-3 text-sm leading-7 ${center ? "text-center" : "text-gray-600"}`}>{a}</p>

    </details>

  );

}



function Testimonial({ name, text }) {

  return (

    <div className="rounded-2xl border p-6 bg-white/70 shadow-sm" style={{ borderColor: primaryColor }}>

      <div className="flex items-center gap-2 mb-2">

        {Array.from({ length: 5 }).map((_, i) => (

          <Star key={i} className="w-4 h-4" style={{ color: primaryColor }} />

        ))}

      </div>

      <p className="text-sm leading-7 text-gray-700 mb-4">{text}</p>

      <div className="text-sm font-semibold">{name}</div>

    </div>

  );

}



function UrgencyBanner() {

  return (

    <section className="text-center py-10 px-4 bg-blue-900 text-white rounded-xl max-w-4xl mx-auto">

      <h2 className="text-2xl sm:text-3xl font-bold">Every Week of Delay = <span className="text-green-400">Another Concept Missed</span></h2>

      <p className="text-gray-200 mt-3">Don’t wait until your child’s next exam struggle — start now.</p>

      <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm text-gray-200">

        <div className="flex items-center gap-2">

          <CheckCircle2 className="w-4 h-4 text-green-400" />

          No Credit Card Required

        </div>

        <div className="flex items-center gap-2">

          <CheckCircle2 className="w-4 h-4 text-green-400" />

          Hassle-Free, 100% Free Demo

        </div>

        <div className="flex items-center gap-2">

          <CheckCircle2 className="w-4 h-4 text-green-400" />

          Limited Slots This Week

        </div>

      </div>

      <div className="mt-6">

        <a href="https://wa.link/wp92sb" target="_blank" rel="noreferrer" className="bg-green-500 text-white font-semibold rounded-full px-8 py-3 inline-block hover:bg-green-600 transition">Book Free Demo Class</a>

      </div>

    </section>

  );

}



export default function ULearnLanding() {

  const [active, setActive] = useState("home");



  useEffect(() => {

    const ids = ["home", "subjects", "pricing", "demo", "why", "faq", "contact"];

    const observer = new IntersectionObserver(

      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting && entry.target.id) setActive(entry.target.id);

        });

      },

      { root: null, rootMargin: "-40% 0px -40% 0px", threshold: 0 }

    );

    ids.forEach((id) => {

      const el = document.getElementById(id);

      if (el) observer.observe(el);

    });

    return () => observer.disconnect();

  }, []);



  return (

    <div className="min-h-screen text-gray-900 bg-gray-50">

      <header className={`sticky top-0 z-50 bg-white/90 backdrop-blur-md transition-shadow ${active !== "home" ? "shadow-md" : ""}`}>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
<a href="#home" className="flex items-center gap-2 font-extrabold text-xl tracking-tight" style={{ color: primaryColor }}>
  <img src="/logoo.png" alt="U-Learn Logo" className="w-8 h-8" />
  U-Learn Academy
</a>

          <nav className="hidden md:flex items-center gap-6 text-sm font-medium">

            <a href="#subjects" className={`hover:text-blue-600 transition ${active === "subjects" ? "text-[#5c87ff] underline" : ""}`}>

              Subjects

            </a>

            <a href="#pricing" className={`hover:text-blue-600 transition ${active === "pricing" ? "text-[#5c87ff] underline" : ""}`}>

              Pricing & Packages

            </a>

            <a href="#why" className={`hover:text-blue-600 transition ${active === "why" ? "text-[#5c87ff] underline" : ""}`}>

              Why U-Learn

            </a>

            <a href="#faq" className={`hover:text-blue-600 transition ${active === "faq" ? "text-[#5c87ff] underline" : ""}`}>

              FAQ

            </a>

            <a href="#contact" className={`hover:text-blue-600 transition ${active === "contact" ? "text-[#5c87ff] underline" : ""}`}>

              Contact

            </a>

          </nav>

          <a

            href="https://wa.link/8o7ef2"

            target="_blank"

            rel="noopener noreferrer"

            className="hidden sm:inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm"

            style={{ borderColor: primaryColor, color: primaryColor }}

          >

            <PhoneCall className="w-4 h-4" style={{ color: primaryColor }} />

            WhatsApp

          </a>

        </div>

      </header>



      <main className="scroll-smooth">

        <Section id="home" className="pt-10 pb-8">

          <div className="grid lg:grid-cols-2 gap-10 items-center">

            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="space-y-6">

              <Pill>Online • Grades 1-12 & beyond</Pill>

              <h1 className="text-3xl sm:text-5xl font-extrabold leading-tight">Learn anywhere, anytime — with tutors who make it simple.</h1>

              <p className="text-gray-600 max-w-xl">U-Learn Academy offers 1-on-1 and small-group online tutoring across all subjects. Clear explanations, flexible timings, and real progress.</p>

              <div className="flex flex-wrap gap-3">

                <Button href="https://wa.link/wp92sb" filled>Book Free Demo</Button>

                <Button href="#pricing">See Offers</Button>

              </div>

              <div className="flex items-center gap-4 text-sm text-gray-600">

                <div className="flex items-center gap-2">

                  <BadgeCheck className="w-4 h-4" style={{ color: primaryColor }} /> Certified Tutors

                </div>

                <div className="flex items-center gap-2">

                  <Users className="w-4 h-4" style={{ color: primaryColor }} /> 1-on-1 or Groups

                </div>

                <div className="flex items-center gap-2">

                  <CalendarClock className="w-4 h-4" style={{ color: primaryColor }} /> Flexible Schedules

                </div>

              </div>

            </motion.div>



            <div className="relative">
<div
  className="aspect-[4/3] rounded-3xl border overflow-hidden shadow-lg flex items-center justify-center bg-cover bg-center"
  style={{
    borderColor: primaryColor,
    backgroundImage: "url('/brain.png')",
  }}
>

<div className="text-center p-8 pt-4">
  <h2 className="font-extrabold text-2xl text-white mb-6">U-Learn Academy</h2>

  <h3 className="font-semibold text-lg mb-2 text-white">Starting Now</h3>
  <p className="text-sm text-blue-100">Pre-season offers live • Free demo available</p>
</div>


              </div>

            </div>

          </div>

        </Section>



        <Section id="subjects">

          <div className="mb-10">

            <Pill>All Subjects. All Grades.</Pill>

            <h2 className="text-2xl sm:text-4xl font-bold mt-3">Subjects we teach</h2>

            <p className="text-gray-600 mt-2 max-w-2xl">From fundamentals to advanced topics — personalized plans that match each learner's pace.</p>

          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">

            <Feature Icon={BookOpen} title="Mathematics" desc="Arithmetic, Algebra, Geometry, Calculus, SAT & university prep." />

            <Feature Icon={Zap} title="Sciences" desc="Physics, Chemistry, Biology — concept clarity with visual explanations." />

            <Feature Icon={Globe} title="Languages" desc="English, Arabic, French — grammar, writing, speaking, and exam prep." />

            <Feature Icon={MessageCircle} title="Skills & Study" desc="Study plans, note-taking, problem-solving, and confidence building." />

            <Feature Icon={GraduationCap} title="Beyond School" desc="University foundations, entrance prep, and bridging courses." />

          </div>

        </Section>



        <Section id="pricing">

          <div className="mb-10 text-center">

            <Pill>Pricing Packages</Pill>

            <h2 className="text-2xl sm:text-4xl font-bold mt-3">Simple plans that scale with you</h2>

            <p className="text-gray-600 mt-2">Start with a free demo. Upgrade anytime.</p>

          </div>



          <div className="grid md:grid-cols-3 gap-6">

            <div className="rounded-3xl border p-6 bg-white/70 shadow-sm" style={{ borderColor: primaryColor }}>

              <div className="mt-2 text-3xl font-extrabold">Grades 1-8</div>

              <ul className="mt-4 space-y-2 text-sm text-gray-700">

                <li>• 1 Session: $20</li>

                <li>• 10 Sessions: $170 (Save $30)</li>

                <li>• 50 Sessions: $800 (Save $200)</li>

              </ul>

              <Button href="https://wa.link/wp92sb" filled className="mt-6 w-full">Try Free Demo</Button>

            </div>



            <div className="rounded-3xl border p-6 bg-white shadow-md relative" style={{ borderColor: primaryColor }}>

              <div className="mt-2 text-3xl font-extrabold">Grades 9-12</div>

              <ul className="mt-4 space-y-2 text-sm text-gray-700">

                <li>• 1 Session: $25</li>

                <li>• 10 Sessions: $200 (Save $50)</li>

                <li>• 50 Sessions: $900 (Save $350)</li>

              </ul>

              <Button href="https://wa.link/wp92sb" filled className="mt-6 w-full">Try Free Demo</Button>

            </div>



            <div className="rounded-3xl border p-6 bg-white/70 shadow-sm" style={{ borderColor: primaryColor }}>

              <div className="text-sm font-semibold">Other Benefits</div>

              <ul className="mt-4 space-y-2 text-sm text-gray-700">

                <li>• 1-To-1 Live Teaching and Solving</li>

                <li>• Assignment Help</li>

                <li>• Need More Sessions? We're Flexible</li>

                <li>• Change Class Date/Time, Hassle Free</li>

              </ul>

            </div>

          </div>



          <div className="mt-6 grid place-items-center">

            <div className="rounded-3xl border p-6 bg-white/70 shadow-sm max-w-3xl w-full" style={{ borderColor: primaryColor }}>

              <ul className="mt-4 space-y-2 text-sm text-gray-700">

                <li>• Doesn't Match Your Needs?</li>

                <li>• Contact Us For A Customized Learning Plan.</li>

              </ul>

              <Button href="https://wa.link/8o7ef2" filled className="mt-6 w-full">Contact us</Button>

            </div>

          </div>

        </Section>



        <Section

          id="demo"

          className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-[2rem] border text-center"

          style={{ borderColor: primaryColor }}

        >

          <h3 className="text-2xl sm:text-3xl font-bold">Book your FREE demo session today</h3>

          <p className="text-gray-600 mt-2">Limited pre-season spots available — reserve yours now.</p>

          <div className="mt-6 flex flex-wrap gap-3 justify-center">

            <Button href="https://wa.link/1wrgo3" filled>Reserve My Spot</Button>

            <Button href="#faq">How does it work?</Button>

          </div>

        </Section>



        <Section id="why">

          <div className="mb-10 text-center">

            <Pill>Why U-Learn Academy</Pill>

            <h2 className="text-2xl sm:text-4xl font-bold mt-3">Comprehensive learning features designed for student success</h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

            <Feature Icon={GraduationCap} title="Expert Certified Teachers" desc="Qualified educators with proven track records in student success." />

            <Feature Icon={Users} title="1-on-1 Teaching" desc="Personalized attention and instant doubt-solving for better understanding." />

            <Feature Icon={MessageCircle} title="Live Interactive Classes" desc="Engaging real-time sessions with interactive learning tools." />

            <Feature Icon={BookOpen} title="Visual Learning" desc="Concept-based learning with visuals that make complex topics simple." />

            <Feature Icon={CalendarClock} title="Flexible Timings" desc="Learn at your convenience with flexible scheduling options." />

            <Feature Icon={CreditCard} title="Affordable Fees" desc="Quality education that doesn't break the bank for families." />

            <Feature Icon={CheckCircle2} title="Progress Tracking" desc="Weekly tests and monthly reports to monitor improvement." />

            <Feature Icon={Star} title="Free Demo Classes" desc="Try before you commit with our complimentary demo sessions." />

          </div>

        </Section>



        <Section id="faq">

          <div className="mb-10 text-center">

            <Pill>FAQ</Pill>

            <h2 className="text-2xl sm:text-4xl font-bold mt-3">Common questions</h2>

          </div>

          <div className="grid md:grid-cols-2 gap-5">

            <FAQItem q="Is the demo really free?" a="Yes. The demo helps us understand your level and goals, and you can see our teaching style before enrolling." />

            <FAQItem q="Which grades and subjects do you cover?" a="All subjects from Grades 1 to 12, plus university foundations and exam prep." />

            <FAQItem q="Do you offer 1-on-1 and group classes?" a="Yes. Choose what suits you best. We also create custom study plans." />

            <FAQItem q="How are classes conducted?" a="Online via Zoom or Google Meet, with shared notes, practice, and assignments." />

            <FAQItem q="Which curriculum do you follow?" a="We follow State Boards, and International Boards like IGCSE/IB." />

            <FAQItem q="What is the duration of each online class?" a="Classes are typically 45 minutes to 1 hour long, depending on the grade level and subject." />

            <FAQItem q="What if my child misses a class?" a="We will reschedule the session at a convenient time." />

            <FAQItem q="Can you match the teaching with my child's school syllabus?" a="Yes, we customize lessons as per school textbooks and exam schedules." />

            <FAQItem q="Are the teachers qualified?" a="Yes, all teachers are qualified, experienced, and trained in online teaching." />

            <FAQItem q="What if the teacher misses a class?" a="It will be rescheduled or an extra session will be provided at no cost." />

            <FAQItem q="Can I pay fees monthly or quarterly?" a="Yes, we offer flexible payment options." />

            <FAQItem q="Is there a discount for siblings or group enrollment?" a="Yes, we offer sibling discounts and group offers." />

            <div className="md:col-span-2 flex justify-center">

              <details className="group border rounded-2xl px-6 py-3 text-white w-full max-w-xl" style={{ borderColor: primaryColor, backgroundColor: primaryColor }}>

                <summary className="cursor-pointer list-none flex items-center justify-between w-full">

                  <span className="font-medium w-full text-center">How does it work?</span>

                  <span className="text-white font-bold border border-white rounded-full w-5 h-5 flex items-center justify-center text-xs ml-2 shrink-0">?</span>

                </summary>

                <p className="mt-3 text-sm leading-7 text-center text-white">Choose a subject, Book a free demo, Attend 1-to-1 Live Demo, Get Feedback + Plan, Start Regular Sessions.</p>

              </details>

            </div>

          </div>

        </Section>



        <Section id="contact" className="pt-8">

          <div className="grid lg:grid-cols-2 gap-10 items-start">

            <div>

              <Pill>Get in touch</Pill>

              <h2 className="text-2xl sm:text-4xl font-bold mt-3">Start your learning journey</h2>

              <p className="text-gray-600 mt-2">Reach out on WhatsApp or email and we'll reply within 24 hours.</p>



              <div className="mt-6 space-y-3 text-sm">
  <div className="flex items-center gap-6">
  <div className="flex items-center gap-2">
    <PhoneCall className="w-4 h-4" style={{ color: primaryColor }} />
    <div className="flex items-center gap-2">
    <a href="https://wa.link/8o7ef2" target="_blank" rel="noopener noreferrer" style={{ color: primaryColor }}>{what}</a>
  </div><a href="https://wa.link/saklz8" target="_blank" rel="noopener noreferrer" style={{ color: primaryColor }}>{whatsapp}</a>
  </div>

  
</div>

  <div className="flex items-center gap-3">
    <ul><li className="flex items-center gap-2">
                  <MessageCircle className="w-4 h-4" style={{ color: primaryColor }} />
                  <a
                    href="https://www.instagram.com/u_learn.academy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                    style={{ color: primaryColor }}
                  >
                    Instagram: @u_learn.academy
                  </a>
                  </li>
                  <li className="flex items-center gap-2">
                  <MessageCircle className="w-4 h-4" style={{ color: primaryColor }} />
                  <a
                    href="https://www.facebook.com/share/1SM5KvKY8N/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                    style={{ color: primaryColor }}
                  >
                    Facebook: @U-Learn Academy
                  </a>
                  </li>
                  </ul>
  </div>

  <div className="flex items-center gap-3">
    <Globe className="w-4 h-4" style={{ color: primaryColor }} />
    <a href={`mailto:${email}`} style={{ color: primaryColor }}>{email}</a>
  </div>
</div>



              <div className="mt-8 flex gap-3">

                <Button href="https://wa.link/wp92sb" filled>Book Free Demo</Button>

                <Button href="#pricing">View Offers</Button>

              </div>

            </div>

          </div>

        </Section>

        <Section>

          <UrgencyBanner />

        </Section>

       <footer className="mt-10 border-t bg-white">
  <Section className="py-10">
    <div className="grid md:grid-cols-4 gap-8 text-sm">
      
      {/* Logo + About */}
      <div>
        <div className="flex items-center gap-2 font-extrabold text-lg" style={{ color: primaryColor }}>
          <img src="/logoo.png" alt="U-Learn Logo" className="w-8 h-8" />
          U-Learn Academy
        </div>
        <p className="text-gray-600 mt-3">
          Accessible, high-quality online tutoring that builds strong skills and confidence.
        </p>
      </div>

      {/* Subjects */}
      <div>
        <h4 className="font-semibold mb-3">Subjects</h4>
        <ul className="space-y-2 text-gray-700">
          <li>Math</li>
          <li>Sciences</li>
          <li>Languages</li>
        </ul>
      </div>

      {/* Contact */}
      <div>
        <h4 className="font-semibold mb-3">Contact</h4>
        <ul className="space-y-3 text-gray-700">

          {/* WhatsApp Lebanon */}
          <li className="flex items-center gap-2">
            <PhoneCall className="w-4 h-4" style={{ color: primaryColor }} />
            <span className="text-lg">🇱🇧</span>
            <a 
              href="https://wa.link/saklz8" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:underline"
              style={{ color: primaryColor }}
            >
              {whatsapp}
            </a>
          </li>

          {/* WhatsApp KSA */}
          <li className="flex items-center gap-2">
            <PhoneCall className="w-4 h-4" style={{ color: primaryColor }} />
<span className="text-lg">🇸🇦</span>          
 <a href="https://wa.link/8o7ef2" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:underline"
              style={{ color: primaryColor }}
            >
              {what}
            </a>
          </li>

          {/* Email */}
          <li className="flex items-center gap-2">
            <Globe className="w-4 h-4" style={{ color: primaryColor }} />
            <a 
              href={`mailto:${email}`} 
              className="hover:underline" 
              style={{ color: primaryColor }}
            >
              {email}
            </a>
          </li>

          {/* Instagram */}
                  <li className="flex items-center gap-2">
                  <MessageCircle className="w-4 h-4" style={{ color: primaryColor }} />
                  <a
                    href="https://www.instagram.com/u_learn.academy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                    style={{ color: primaryColor }}
                  >
                    Instagram: @u_learn.academy
                  </a>
                  </li>
                  <li className="flex items-center gap-2">
                  <MessageCircle className="w-4 h-4" style={{ color: primaryColor }} />
                  <a
                    href="https://www.facebook.com/share/1SM5KvKY8N/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                    style={{ color: primaryColor }}
                  >
                    Facebook: @U-Learn Academy
                  </a>
                  </li>
                  </ul>
                  </div>
                </div>

                {/* Bottom note */}
    <div className="pt-6 text-xs text-gray-500 border-t mt-6">
      © {new Date().getFullYear()} U-Learn Academy. All rights reserved.
    </div>
  </Section>
</footer>


      </main>

    </div>

  );

}